// Global quantity controls for quick order list
if (!customElements.get('quick-order-list-global-quantity')) {
  customElements.define(
    'quick-order-list-global-quantity',
    class QuickOrderListGlobalQuantity extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        // Cache DOM elements
        this.quickOrderList = this.closest('quick-order-list');
        this.decreaseButton = this.querySelector('[data-action="decrease-all"]');
        this.increaseButton = this.querySelector('[data-action="increase-all"]');
        this.quantityInput = this.querySelector('.global-quantity-input');
        this.applyButton = this.querySelector('[data-action="apply-to-all"]');
        
        // Add event listeners if elements exist
        if (this.decreaseButton && this.increaseButton && this.quantityInput && this.applyButton) {
          this.decreaseButton.addEventListener('click', this.decreaseAll.bind(this));
          this.increaseButton.addEventListener('click', this.increaseAll.bind(this));
          this.applyButton.addEventListener('click', this.applyToAll.bind(this));
          
          // Add input validation
          this.quantityInput.addEventListener('input', this.validateInput.bind(this));
        }
      }

      validateInput() {
        // Ensure quantity is a positive number
        let value = parseInt(this.quantityInput.value);
        if (isNaN(value) || value < 0) {
          this.quantityInput.value = 0;
        }
      }

      decreaseAll(event) {
        event.preventDefault();
        const currentValue = parseInt(this.quantityInput.value) || 0;
        if (currentValue > 0) {
          this.quantityInput.value = currentValue - 1;
        }
      }

      increaseAll(event) {
        event.preventDefault();
        const currentValue = parseInt(this.quantityInput.value) || 0;
        this.quantityInput.value = currentValue + 1;
      }

      applyToAll(event) {
        event.preventDefault();
        const quantity = parseInt(this.quantityInput.value) || 0;
        
        // Get all variant inputs
        const variantInputs = this.quickOrderList.querySelectorAll('input[type="number"][data-quantity-variant-id]');
        if (!variantInputs.length) return;
        
        // Apply the global quantity to all variants
        const updates = this.calculateVariantUpdates(variantInputs, quantity);
        
        // Update the cart with all variant quantities
        if (Object.keys(updates).length) {
          this.quickOrderList.toggleLoading(true);
          this.quickOrderList.updateMultipleQty(updates);
        }
      }
      
      calculateVariantUpdates(inputs, quantity) {
        const updates = {};
        
        inputs.forEach(input => {
          const variantId = input.dataset.quantityVariantId;
          if (!variantId) return;
          
          // Get variant quantity rules
          const minQty = parseInt(input.dataset.min) || 1;
          const maxQty = input.max ? parseInt(input.max) : null;
          const step = parseInt(input.step) || 1;
          
          // Calculate valid quantity based on rules
          let validQuantity = this.getValidQuantity(quantity, minQty, maxQty, step);
          
          // Update the input value
          input.value = validQuantity;
          
          // Add to updates object for cart update
          updates[variantId] = validQuantity;
        });
        
        return updates;
      }
      
      getValidQuantity(quantity, min, max, step) {
        // Apply minimum rule
        let validQuantity = quantity;
        
        if (quantity > 0 && validQuantity < min) {
          validQuantity = min;
        }
        
        // Apply maximum rule
        if (max !== null && validQuantity > max) {
          validQuantity = max;
        }
        
        // Apply step rule
        if (quantity > 0 && validQuantity % step !== 0) {
          validQuantity = Math.floor(validQuantity / step) * step;
          if (validQuantity < min) {
            validQuantity = min;
          }
        }
        
        return validQuantity;
      }
    }
  );
} 